<template>
  <div :class="classes">
      <pt-page-title title="第三方供应商">
          <template slot="before-left">
            <el-button type="primary" @click="createdThirdVendors">创建第三方供应商</el-button>
          </template>
      </pt-page-title>
      <pt-page-factor-filter :labels="couponGoodsLabs" v-model="filterCondition"  isQueryRouter @Filter="Filter" ref="filter">
        <template>
            <el-button type="primary" @click="Filter()">筛选</el-button>
            <!-- <el-button type="primary" @click="toEduce">导出</el-button> -->
          </template>
      </pt-page-factor-filter>
      <pt-third-vendors-table :tableLabel="thirdVendorsLabels" :params-data="parmasData" ref="tableWithData"  :isFromRouter="isFromRouter">
          <el-table-column label="操作">
              <div slot-scope="scope" :class="$style['opreation-button']">
                  <i class="iconfont icon-xiangqing" @click="goVendorDetail(scope.row)"></i>
                  <i class="iconfont icon-bianji"  @click="editVendor(scope.row)"></i>
                <i class="iconfont icon-shanchu"  @click="deleteVendor(scope.row)"></i>
              </div>
          </el-table-column>
      </pt-third-vendors-table>
  </div>
</template>

<script>
// 组件class前缀
import ptThirdVendorsTable from './pt-third-vendors-table/withData'
import { couponGoodsLabs, thirdVendorsLabels } from './third-vendors.js'
const prefixCls = 'pt-third-vendors'
export default {
  name: 'pt-third-vendors',
  components: {
    ptThirdVendorsTable
  },
  props: {
    vendorTypes: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  data () {
    return {
      couponGoodsLabs: couponGoodsLabs,
      thirdVendorsLabels: thirdVendorsLabels,
      filterCondition: {},
      parmasData: null,
      isFromRouter: false
    }
  },
  watch: {
    vendorTypes: {
      handler: function (val) {
        this.couponGoodsLabs.forEach(item => {
          if (item.value === 'type') {
            item.options = val
          }
        })
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    createdThirdVendors () {
      this.$router.push('/third-vendors/third-vendor-form/false/0')
    },
    Filter (isFromRouter) {
      this.isFromRouter = isFromRouter
      for (let key in this.filterCondition) {
        if (!this.filterCondition[key]) {
          this.$delete(this.filterCondition, key)
        }
      }
      if (!isFromRouter) {
        this.$refs.filter.getAddRouter(this.filterCondition)
      }
      this.parmasData = { ...this.filterCondition }
    },
    editVendor (row) {
      this.$router.push(`/third-vendors/third-vendor-form/true/${row.id}`)
    },
    goVendorDetail (row) {
      this.$router.push(`/third-vendors-detail/${row.id}`)
    },
    deleteVendor (row) {
      this.$confirm(`确定要删除第三方供应商：${row.name}?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // console.log('this.$refs.tableWithData.load()', this.$refs)
        // console.log('this.$refs.tableWithData.load()', this.$refs.tableWithData)
        // this.$refs.tableWithData.load()
        this.$store.dispatch('deleteVendor', row.id).then(data => {
          console.log('this.$refs.tableWithData.load()', this.$refs)
          console.log('this.$refs.tableWithData.load()', this.$refs.tableWithData)
          this.$refs.tableWithData.load()
          this.$message.success('删除成功！')
        }).catch(err => {
          this.$message.error(err)
        })
      })
    },
    toEduce () {
      this.$refs.tableWithData.toEduce()
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.opreation-button{
    :global
    .iconfont{
        margin-right: 10px;
    }
}
</style>
